import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    EventEmitter,
    Output
} from '@angular/core';
import { TraceClassDecorator } from '@sentry/angular';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
    name_input,
    address,
    city,
    phoneNumber,
    zipCode,
    textareaBox,
    dose_input,
    number_input,
    medication_name_input,
    blockSpecialCharachters
} from 'src/app/constant/constant';
import {
    Allergy,
    medicalHistoryApiData,
    medicalHistoryUiEdit,
    Medication,
    SocialHistory_Alcohol,
    SocialHistory_Smoking
} from 'src/app/models/history';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { MedicalHistoryService } from './../../../services/medical-history.service';
@Component({
    selector: 'app-medical-history-ui-edit',
    templateUrl: './medical-history-ui-edit.component.html',
    styleUrls: ['./medical-history-ui-edit.component.css'],
    providers: [MessageService, ConfirmationService]
})
@TraceClassDecorator()
export class MedicalHistoryUiEditComponent implements OnInit, OnDestroy {
    @Input('patientData') patientData: medicalHistoryApiData

    @Output('onSaveClick') onSaveClick: EventEmitter<medicalHistoryApiData> =
        new EventEmitter<medicalHistoryApiData>();

    readonly name_input: RegExp = name_input;
    readonly address: RegExp = address;
    readonly city_input: RegExp = city;
    readonly phoneNumber: RegExp = phoneNumber;
    readonly zipCode: RegExp = zipCode;
    readonly textarea: RegExp = textareaBox;
    readonly dose_input: RegExp = dose_input;
    readonly number_input: RegExp = number_input;
    readonly medication_name_input: RegExp = medication_name_input;
    readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;

    constructor(
        private readonly medicalHistoryService: MedicalHistoryService,
        private readonly utilitiesService: UtilitiesService,
        private readonly confirmationService: ConfirmationService,
        private readonly messageService: MessageService
    ) {}

    medicalHistoryUiEdit_data: medicalHistoryUiEdit =
        this.medicalHistoryService.init_medicalHistoryUiEdit();

    async ngOnInit(): Promise<void> {
      if(!this.patientData) this.patientData = this.medicalHistoryService.init_medicalHistoryApiData();
        await this.init_data();
    }

    ngOnDestroy() {}

    async saving_data() {
        this.onSaveClick.emit(this.medicalHistoryUiEdit_data.others.data);
    }

    async init_data() {
        this.medicalHistoryUiEdit_data.others.data = this.patientData;
        this.medicalHistoryUiEdit_data.others.medication_columns = [
            'Sr. No.',
            'Medications',
            'Dose',
            'Times per day',
            'Instructions'
        ];

        this.medicalHistoryUiEdit_data.others.allergy_columns = [
            'Sr. No.',
            'Allergy',
            'Allergic Reaction'
        ];
        this.medicalHistoryUiEdit_data.others.medical_history_row = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11
        ];
        this.medicalHistoryUiEdit_data.others.years =
            this.utilitiesService.generate_years_list(
                1900,
                this.medicalHistoryUiEdit_data.others.year,
                false
            );
    }

    disableAll() {
        if (
            this.medicalHistoryUiEdit_data.others.none_selected_medical_history
        ) {
            this.medicalHistoryUiEdit_data.others.data.selected_past_medical_history_data =
                [];
            for (const med_hist of this.medicalHistoryUiEdit_data.others.data
                .past_medical_history_data)
                med_hist.selected = false;
        }
    }

    async addMedicalHistory() {
        if (
            this.medicalHistoryUiEdit_data.others.medical_history_value.length >
            0
        ) {
            if (
                !this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
            ) {
                this.medicalHistoryUiEdit_data.others.data.past_medical_history_data.push(
                    {
                        id: this.medicalHistoryUiEdit_data.others.data
                            .past_medical_history_data.length,
                        name: this.medicalHistoryUiEdit_data.others
                            .medical_history_value,
                        selected: true
                    }
                );
            } else if (
                this.medicalHistoryUiEdit_data.others
                    .none_selected_medical_history
            ) {
                this.medicalHistoryUiEdit_data.others.data.past_medical_history_data.push(
                    {
                        id: this.medicalHistoryUiEdit_data.others.data
                            .past_medical_history_data.length,
                        name: this.medicalHistoryUiEdit_data.others
                            .medical_history_value,
                        selected: false
                    }
                );
            }
            this.medicalHistoryUiEdit_data.others.medical_history_value = '';
            this.medicalHistoryUiEdit_data.others.medical_history_row.push(
                this.medicalHistoryUiEdit_data.others.medical_history_row.length
            );
            this.medicalHistoryUiEdit_data.others.more_medical = false;
        }
    }

    addData(form: string) {
        if (form == 'medication') {
            if (
                this.medicalHistoryUiEdit_data.others.add_temp_medication.name
                    .length > 0 &&
                this.medicalHistoryUiEdit_data.others.add_temp_medication.dose
                    .length > 0
            ) {
                this.medicalHistoryUiEdit_data.others.data.medications.push({
                    id:
                        this.medicalHistoryUiEdit_data.others.data.medications
                            .length + 1,
                    name: this.medicalHistoryUiEdit_data.others
                        .add_temp_medication.name,
                    dose: this.medicalHistoryUiEdit_data.others
                        .add_temp_medication.dose,
                    // times_per_day: this.times_per_day.length>0?this.times_per_day:"N/A",
                    // instructions: this.instructions.length>0?this.instructions:"N/A"
                    times_per_day:
                        this.medicalHistoryUiEdit_data.others
                            .add_temp_medication.times_per_day,
                    instructions:
                        this.medicalHistoryUiEdit_data.others
                            .add_temp_medication.instructions
                });
                this.message_service(
                    this.medicalHistoryUiEdit_data.others.add_temp_medication
                        .name + ' medication has been added'
                );
            }
        } else if (form == 'allergy') {
            if (
                this.medicalHistoryUiEdit_data.others.add_temp_allergy.name
                    .length > 0 &&
                this.medicalHistoryUiEdit_data.others.add_temp_allergy.reaction
                    .length > 0
            ) {
                this.medicalHistoryUiEdit_data.others.data.allergies.push({
                    id:
                        this.medicalHistoryUiEdit_data.others.data.allergies
                            .length + 1,
                    name: this.medicalHistoryUiEdit_data.others.add_temp_allergy
                        .name,
                    reaction:
                        this.medicalHistoryUiEdit_data.others.add_temp_allergy
                            .reaction
                });
                this.message_service(
                    this.medicalHistoryUiEdit_data.others.add_temp_allergy
                        .name + ' allergy has been added'
                );
            }
        }
        this.resetTemp(form);
    }

    resetTemp(form: string) {
        if (form == 'medication') {
            this.medicalHistoryUiEdit_data.others.medication_edit_id = -1;
            this.medicalHistoryUiEdit_data.others.add_temp_medication =
                this.medicalHistoryService.init_Medication();
            this.medicalHistoryUiEdit_data.others.edit_temp_medication =
                this.medicalHistoryService.init_Medication();
        } else if (form == 'allergy') {
            this.medicalHistoryUiEdit_data.others.allergy_edit_id = -1;
            this.medicalHistoryUiEdit_data.others.add_temp_allergy =
                this.medicalHistoryService.init_Allergy();
            this.medicalHistoryUiEdit_data.others.edit_temp_allergy =
                this.medicalHistoryService.init_Allergy();
        }
        this.medicalHistoryUiEdit_data.others.delete_header_name = '';
    }

    editData(row, form: string) {
        if (form == 'medication') {
            this.resetTemp(form);
            let a: Medication = row;
            this.medicalHistoryUiEdit_data.others.medication_edit_id = a.id;
            this.medicalHistoryUiEdit_data.others.edit_temp_medication =
                this.shallow_copy(a);
        } else if (form == 'allergy') {
            this.resetTemp(form);
            let a: Allergy = row;
            this.medicalHistoryUiEdit_data.others.allergy_edit_id = a.id;
            this.medicalHistoryUiEdit_data.others.edit_temp_allergy =
                this.shallow_copy(a);
        }
    }

    async confirmDelete(event: Event, form: string, row: any) {
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (form == 'medication') {
            this.resetTemp(form);
            this.medicalHistoryUiEdit_data.others.delete_header_name =
                'Delete Medication';
            let message =
                'Are you sure to delete the medication ' + row.name + '?';
            await this.confirmation_service(
                'Delete Medication',
                message,
                form,
                row
            );
        } else if (form == 'allergy') {
            this.resetTemp(form);
            this.medicalHistoryUiEdit_data.others.delete_header_name =
                'Delete Allergy';
            let message =
                'Are you sure to delete the allergy ' + row.name + '?';
            await this.confirmation_service(
                'Delete Allergy',
                message,
                form,
                row
            );
        }
    }

    async confirmation_service(
        header: string,
        message: string,
        form: string,
        row: any
    ) {
        this.confirmationService.confirm({
            key: 'confirm-delete',
            message: message,
            header: header,
            accept: () => {
                this.deleteData(form, row);
            }
        });
    }

    message_service(detail: string) {
        this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: detail
        });
    }

    deleteData(form: string, row: any) {
        if (form == 'medication') {
            let a: Medication = row;
            let index =
                this.medicalHistoryUiEdit_data.others.data.medications.findIndex(
                    (e) => e == a
                );
            this.medicalHistoryUiEdit_data.others.data.medications =
                this.delete_row(
                    'id',
                    index,
                    this.medicalHistoryUiEdit_data.others.data.medications
                );
        } else if (form == 'allergy') {
            let a: Allergy = row;
            let index =
                this.medicalHistoryUiEdit_data.others.data.allergies.findIndex(
                    (e) => e == a
                );
            this.medicalHistoryUiEdit_data.others.data.allergies =
                this.delete_row(
                    'id',
                    index,
                    this.medicalHistoryUiEdit_data.others.data.allergies
                );
        }
    }

    delete_row(index_key: string, index: number, data: any[]) {
        data.splice(index, 1);
        return this.reinit_index(index_key, data);
    }

    reinit_index(index_key: string, data: any[]) {
        let i = 1;
        data.map((ele) => (ele[index_key] = i++));
        return data;
    }

    canceleditData(row, form: string) {
        if (form == 'medication') {
            let a: Medication = row;
            this.medicalHistoryUiEdit_data.others.medication_edit_id = -1;
            let index =
                this.medicalHistoryUiEdit_data.others.data.medications.findIndex(
                    (e) => e == a
                );
            this.medicalHistoryUiEdit_data.others.data.medications[index] =
                this.shallow_copy(
                    this.medicalHistoryUiEdit_data.others.edit_temp_medication
                );
        } else if (form == 'allergy') {
            let a: Allergy = row;
            this.medicalHistoryUiEdit_data.others.allergy_edit_id = -1;
            let index =
                this.medicalHistoryUiEdit_data.others.data.allergies.findIndex(
                    (e) => e == a
                );
            this.medicalHistoryUiEdit_data.others.data.allergies[index] =
                this.shallow_copy(
                    this.medicalHistoryUiEdit_data.others.edit_temp_allergy
                );
        }
        this.resetTemp(form);
    }

    shallow_copy(a) {
        return this.utilitiesService.shallow_copy(a);
    }

    onSocialHistoryChange(form: string) {
        if (form == 'smoking') {
            let a: SocialHistory_Smoking =
                this.medicalHistoryService.init_Smoking();
            this.medicalHistoryUiEdit_data.others.data.social_history.smoking.data =
                this.shallow_copy(a.data);
        } else if (form == 'alcohol') {
            let a: SocialHistory_Alcohol =
                this.medicalHistoryService.init_Alcohol();
            this.medicalHistoryUiEdit_data.others.data.social_history.alcohol.data =
                this.shallow_copy(a.data);
        }
    }

    async saveData(row, form: string) {
        this.resetTemp(form);
    }
   
}
